module.exports = __webpack_public_path__ + "img/LINK.62c346a9.svg";